<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined dense class="text-xs-center"
                v-model="searchParamCodigo" append-icon="search"
                label="Búsqueda por código" hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined dense class="text-xs-center"
                v-model="searchParamDescripcion" append-icon="search"
                label="Búsqueda por descripción" hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="6">
              <v-toolbar-title class="font-weight-black primary--text">Planillas</v-toolbar-title>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large @click="mostrarBusqueda" color="primary" v-bind="attrs" v-on="on">
                <v-icon dark>{{ mostrarBusquedas ? "search_off" : "search" }}</v-icon>
              </v-btn>
            </template>
            <span>{{ mostrarBusquedas ? "Ocultar filtros de búsqueda" : "Mostrar filtros de búsqueda" }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large @click="mostrarInactivos" color="primary" v-bind="attrs" v-on="on">
                <v-icon dark>{{ !inactivos ? "visibility_off" : "visibility" }}</v-icon>
              </v-btn>
            </template>
            <span>{{ !inactivos ? "Ocultar Inactivos" : "Mostrar Inactivos" }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large @click="agregar" color="primary" v-bind="attrs" v-on="on">
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
        </v-app-bar>

        <v-sheet class="overflow-y-auto" :max-height="height + 160">
          <v-data-table
            dense fixed-header
            :height="height - 210"
            :headers="headers"
            :items="planillas"
            :items-per-page="50"
            sort-by="codigo"
            class="elevation-1"
            :loading="dtPlanillasLoad"
            loading-text="Cargando... Espere por favor"
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{ showFirstLastPage: true, 'items-per-page-text': 'Filas por página', 'items-per-page-options': [50, 100, 150, 200, -1] }"
          >
            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'B' || item.estado == '0'">
                <v-btn color="error" x-small text dark @click="abrirDialogActivacion(item)">
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn color="success" x-small text dark @click="abrirDialogActivacion(item)">
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.codigo`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small text dark color="primary" class="font-weight-bold" @click="editar(item)" v-bind="attrs" v-on="on">
                    {{ item.codigo }}
                  </v-btn>
                </template>
                <span>Editar Planilla</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.personas`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small text dark color="primary" class="font-weight-bold" @click="manageDetalles(item)" v-bind="attrs" v-on="on">
                    <v-icon x-small>people</v-icon> Ver Personas
                  </v-btn>
                </template>
                <span>Administrar Detalles de Planilla</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.incrementos`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small text dark color="primary" class="font-weight-bold" @click="abrirConfiguracionIncrementos(item)" v-bind="attrs" v-on="on">
                    <v-icon x-small>settings</v-icon> Incrementos
                  </v-btn>
                </template>
                <span>Configurar Fases de Incremento</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="listar">Cargar</v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>


      <!-- DIALOG FORM FOR CRUD PLANILLA -->
      <v-dialog v-model="dialogForm" max-width="650px" persistent>
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title><span class="headline">{{ formTitle }}</span></v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="guardar" color="primary" v-bind="attrs" v-on="on" fab>
                  <v-icon dark>fa-solid fa-save</v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="cerrar" color="primary" v-bind="attrs" v-on="on" fab>
                  <v-icon dark>fa-solid fa-xmark</v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined dense ref="codigo"
                    v-model="codigo"
                    :readonly="!editarCodigo"
                    :rules="[rules.requerido]"
                    label="Código" placeholder="Código de Planilla" required
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                  ></v-text-field>

                  <v-textarea
                    outlined dense :rows="2" ref="descripcion"
                    v-model="descripcion"
                    label="Descripción" placeholder="Descripción opcional"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- ACTIVATION DIALOG -->
      <v-dialog v-model="dialogActivacion" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text>
            <span v-if="accionActual === 'planilla'">Esta acción {{ estado == 'A' || estado == '1' ? 'desactivará' : 'activará' }} el elemento seleccionado.</span>
            <span v-else-if="accionActual === 'detalle'">Seguro que desea eliminar esta persona de la planilla?</span>
            <span v-else-if="accionActual === 'detalleMasivo'">Se {{ selectDetalles.length === 1 ? 'eliminará' : 'eliminarán' }} {{ selectDetalles.length }} {{ selectDetalles.length === 1 ? 'persona' : 'personas' }} de la planilla.</span>
            <span v-else-if="accionActual === 'importarPersonas'">Este proceso sincronizará la planilla: importará a las nuevas personas activas que tengan un cupo asignado, y desactivará de la planilla a aquellas que ya no cumplan con esta condición.</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogActivacion = false">Cancelar</v-btn>
            <div v-if="accionActual === 'planilla'">
              <v-btn v-if="estado == 'A' || estado == '1'" color="primary" text @click="desactivar()">Continuar</v-btn>
              <v-btn v-else color="primary" text @click="activar()">Continuar</v-btn>
            </div>
            <div v-else-if="accionActual === 'detalle'">
              <v-btn color="primary" text @click="confirmarDesactivarDetalle()">Continuar</v-btn>
            </div>
            <div v-else-if="accionActual === 'detalleMasivo'">
              <v-btn color="primary" text @click="confirmarDesactivarMasivo()">Continuar</v-btn>
            </div>
            <div v-else-if="accionActual === 'importarPersonas'">
              <v-btn color="primary" text @click="confirmarImportarPersonas()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-flex>

      <!-- DIALOG CONFIGURACION DE INCREMENTOS -->
      <v-dialog v-model="dialogIncrementos" max-width="700px" persistent>
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title><span class="headline">Configuración de Incrementos ({{ codigoPlanillaActual }})</span></v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="dialogIncrementos = false" color="primary" v-bind="attrs" v-on="on" fab>
                  <v-icon dark>fa-solid fa-xmark</v-icon>
                </v-btn>
              </template>
              <span>Cerrar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <!-- Formulario de nuevo incremento -->
              <v-row class="mb-2">
                <v-col cols="12" sm="3">
                  <v-text-field outlined dense type="number" v-model.number="formIncremento.mes_inicio" label="Mes Inicio (1-12)"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field outlined dense type="number" v-model.number="formIncremento.mes_fin" label="Mes Fin (1-12)"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field outlined dense type="number" v-model.number="formIncremento.porcentaje" label="Porcentaje (%)"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex align-center">
                  <v-btn color="primary" @click="agregarIncremento" :loading="btnIncrementoLoading" block>Agregar</v-btn>
                </v-col>
              </v-row>
              <!-- Tabla de incrementos -->
              <v-data-table
                dense
                :headers="[
                  { text: 'Mes Inicio', value: 'mes_inicio', class: 'primary white--text text-subtitle-3' },
                  { text: 'Mes Fin', value: 'mes_fin', class: 'primary white--text text-subtitle-3' },
                  { text: 'Porcentaje (%)', value: 'porcentaje', class: 'primary white--text text-subtitle-3' },
                  { text: 'Acciones', value: 'acciones', sortable: false, align: 'right', class: 'primary white--text text-subtitle-3' }
                ]"
                :items="incrementosList"
                :loading="tableIncrementosLoading"
                class="elevation-1"
                hide-default-footer
              >
                <template v-slot:[`item.acciones`]="{ item }">
                  <v-btn icon color="error" x-small @click="eliminarIncremento(item)"><v-icon x-small>delete</v-icon></v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

    <DialogDetallesPlanilla ref="detallesDialog" />
  </v-layout>
</template>

<script>
import axios from "axios";

import DialogDetallesPlanilla from "./DialogDetallesPlanilla.vue";

export default {
  components: { DialogDetallesPlanilla },
  data() {
    return {
      width: 0,
      height: 0,
      planillas: [],
      dtPlanillasLoad: false,
      dialogForm: false,
      dialogActivacion: false,
      dialogDetalles: false,
      usuario: this.$store.state.usuario.user,
      
      headers: [
        { text: "Código", value: "codigo", align: "left", filter: this.filtroCodigo, class: "primary white--text text-subtitle-3" },
        { text: "Descripción", value: "descripcion", align: "left", filter: this.filtroDescripcion, class: "primary white--text text-subtitle-3" },
        { text: "Personas", value: "personas", align: "center", class: "primary white--text text-subtitle-3" },
        { text: "Incrementos", value: "incrementos", align: "center", class: "primary white--text text-subtitle-3" },
        { text: "Activo", sortable: false, filter: this.filtroEstado, value: "estado", align: "center", class: "primary white--text text-subtitle-3" },
      ],
      
      rules: { requerido: (value) => !!value || "Debe llenar este campo." },
      
      searchParamCodigo: "",
      searchParamDescripcion: "",
      searchParamEstado: "A",
      
      esEditado: false,
      editarCodigo: false,
      inactivos: true,
      
      id: "",
      codigo: "",
      descripcion: "",
      estado: "",
      accionActual: 'planilla',
      itemPendiente: null,
      
      // Detalles
      planillaActual: null,
      planillaDetallesList: [],
      cargos: [],

      // Table configuration
      pageDetalle: 1,
      loadTableDetalles: false,
      selectDetalles: [],
      mostrarBusquedas: true,
      searchDetalleValue: "",
      searchCencoDetalleValue: "",
      searchAreaDetalleValue: "",

      dialogIncrementos: false,
      codigoPlanillaActual: "",
      idPlanillaActual: 0,
      incrementosList: [],
      tableIncrementosLoading: false,
      btnIncrementoLoading: false,
      formIncremento: { mes_inicio: null, mes_fin: null, porcentaje: null },
      
      grupos: [],
      
      headersDetalle: [
        { text: "Código", value: "persona_codigo", class: "primary white--text text-subtitle-2" },
        { text: "Nombre", value: "persona_nombre", class: "primary white--text text-subtitle-2" },
        { text: "Cargo", value: "id_cargo", filter: this.filtroAreaDetalle, class: "primary white--text text-subtitle-2" },
        { text: "Grupo", value: "id_grupo_nomina", class: "primary white--text text-subtitle-2" },
        { text: "Sueldo", value: "sueldo", class: "primary white--text text-subtitle-2" },
        { text: "Comisión", value: "comision", class: "primary white--text text-subtitle-2" },
        { text: "Subsidio", value: "subsidio_info", sortable: false, class: "primary white--text text-subtitle-2" },
        { text: "Ingreso", value: "fecha_ingreso", class: "primary white--text text-subtitle-2" },
        { text: "Salida", value: "fecha_salida", class: "primary white--text text-subtitle-2" },
      ],
    };
  },
  
  computed: {
    formTitle() {
      return !this.esEditado ? "Nueva Planilla" : "Actualizar Planilla";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
      };
    },
    cargosEnPlanilla() {
      const idsCargosPresentes = new Set(
        this.planillaDetallesList.map(item => item.id_cargo || item.persona_id_cargo)
      );
      return this.cargos.filter(cargo => idsCargosPresentes.has(cargo.id));
    },
    contarPersonasSeleccionadas() {
      return this.selectDetalles.length;
    },
  },
  
  created() {
    this.listar();
    this.listarCargos();
    this.listarGrupos();
  },
  
  mounted() {
    this.getDimensions();
  },
  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    filtroCodigo(value) {
      if (!this.searchParamCodigo) return true;
      if (!value) return false;
      return value.toLowerCase().includes(this.searchParamCodigo.toLowerCase());
    },
    filtroDescripcion(value) {
      if (!this.searchParamDescripcion) return true;
      if (!value) return false;
      return value.toLowerCase().includes(this.searchParamDescripcion.toLowerCase());
    },
    filtroEstado(value) {
      if (this.searchParamEstado === "") return true;
      return value === this.searchParamEstado;
    },
    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      if (!this.mostrarBusquedas) {
        this.searchParamCodigo = "";
        this.searchParamDescripcion = "";
      }
    },
    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.searchParamEstado = this.inactivos ? "A" : "";
    },
    abrirDialogActivacion(item) {
      this.accionActual = 'planilla';
      this.id = item.id;
      this.estado = item.estado;
      this.dialogActivacion = true;
    },

    listarGrupos() {
      let me = this;
      axios.get("api/grupo_nominas/select").then(function (response) {
        me.grupos = response.data;
      });
    },
    obtenerNombreGrupo(id) {
      const g = this.grupos.find(x => x.id === id);
      return g ? g.descripcion : '';
    },
    obtenerNombreCargo(id) {
      const c = this.cargos.find(x => x.id === id);
      return c ? c.descripcion : '';
    },
    formatoNumero(n, d = 0) {
      if (!n) return '';
      return Number(n).toLocaleString("es-CL", { minimumFractionDigits: d, maximumFractionDigits: d });
    },
    formatoFechaSpanish(fecha) {
      if (!fecha) return "";
      try {
        var m = new Date(fecha);
        var dateString =
          ("0" + m.getUTCDate()).slice(-2) + "-" + ("0" + (m.getUTCMonth() + 1)).slice(-2) + "-" + m.getUTCFullYear();
        return dateString;
      } catch (error) {
        return "";
      }
    },
    filtroCencoDetalle(value) {
      if (!this.searchCencoDetalleValue) return true;
      if (!value) return false;
      return value.toLowerCase().includes(this.searchCencoDetalleValue.toLowerCase());
    },
    filtroAreaDetalle(value, search, item) {
      if (!this.searchAreaDetalleValue) return true;
      const cargoId = item.id_cargo || item.persona_id_cargo;
      return cargoId === this.searchAreaDetalleValue;
    },
    guardarDetalleEnLinea(item) {
      let me = this;
      
      let payload = { ...item };
      payload.usuario = me.usuario;
      
      // Cleanup dates
      if (payload.fecha_ingreso && payload.fecha_ingreso.length > 10) 
          payload.fecha_ingreso = payload.fecha_ingreso.substring(0,10);
      if (payload.fecha_salida && payload.fecha_salida.length > 10) 
          payload.fecha_salida = payload.fecha_salida.substring(0,10);
      if (payload.fecha_subsidio_1 && payload.fecha_subsidio_1.length > 10) 
          payload.fecha_subsidio_1 = payload.fecha_subsidio_1.substring(0,10);
      if (payload.fecha_subsidio_2 && payload.fecha_subsidio_2.length > 10) 
          payload.fecha_subsidio_2 = payload.fecha_subsidio_2.substring(0,10);
      if (payload.fecha_subsidio_3 && payload.fecha_subsidio_3.length > 10) 
          payload.fecha_subsidio_3 = payload.fecha_subsidio_3.substring(0,10);

      axios.put("api/Planilla_Detalles/Actualizar", payload)
        .then(function (response) {
          me.$store.dispatch("setSnackbar", { text: "Registro actualizado exitosamente.", color: "success" });
          me.listarDetalles();
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: "Error al actualizar detalle.", color: "error" });
        });
    },
    desactivarMasivo() {
      if (this.selectDetalles.length === 0) return;
      this.accionActual = 'detalleMasivo';
      this.dialogActivacion = true;
    },
    confirmarDesactivarMasivo() {
      this.dialogActivacion = false;
      let me = this;
      let promesas = this.selectDetalles.map(item => 
        axios.put(`api/Planilla_Detalles/Desactivar/${item.id}`, { usuario: me.usuario })
      );
      
      Promise.all(promesas).then(() => {
        me.selectDetalles = [];
        me.listarDetalles();
        me.$store.dispatch("setSnackbar", { text: "Registros desactivados exitosamente.", color: "success" });
      }).catch(() => {
        me.$store.dispatch("setSnackbar", { text: "Hubo un error desactivando algunos registros.", color: "error" });
      });
    },
    
    
    listar() {
      let me = this;
      me.dtPlanillasLoad = true;
      axios.get("api/planillas/listar")
        .then(function (response) {
          me.planillas = response.data;
          me.dtPlanillasLoad = false;
        })
        .catch(function (error) {
          me.dtPlanillasLoad = false;
          console.log(error);
        });
    },
    listarCargos() {
      let me = this;
      axios.get("api/cargos/listar")
        .then(function (response) {
          me.cargos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    agregar() {
      this.limpiar();
      this.esEditado = false;
      this.editarCodigo = true;
      this.dialogForm = true;
    },
    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogForm = true;
    },
    cerrar() {
      this.dialogForm = false;
      this.limpiar();
    },
    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.esEditado = false;
      this.estado = "";
    },
    guardar() {
      if (!this.$refs.codigo.validate(true)) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      
      let me = this;
      if (this.esEditado) {
        axios.put("api/planillas/actualizar", {
          id: me.id,
          codigo: me.codigo,
          descripcion: me.descripcion,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.cerrar();
          me.listar();
          me.$store.dispatch("setSnackbar", { text: "Registro modificado exitosamente.", color: "success" });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error.response.data, color: "error" });
        });
      } else {
        axios.post("api/planillas/crear", {
          codigo: me.codigo,
          descripcion: me.descripcion,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.cerrar();
          me.listar();
          me.$store.dispatch("setSnackbar", { text: "Registro creado exitosamente.", color: "success" });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error.response.data, color: "error" });
        });
      }
    },
    activar() {
      let me = this;
      axios.put("api/planillas/activar/" + this.id, { usuario: me.usuario })
        .then(function (response) {
          me.dialogActivacion = false;
          me.listar();
          me.$store.dispatch("setSnackbar", { text: "Registro activado exitosamente.", color: "success" });
        });
    },
    desactivar() {
      let me = this;
      axios.put("api/planillas/desactivar/" + this.id, { usuario: me.usuario })
        .then(function (response) {
          me.dialogActivacion = false;
          me.listar();
          me.$store.dispatch("setSnackbar", { text: "Registro desactivado exitosamente.", color: "success" });
        });
    },
    abrirConfiguracionIncrementos(item) {
      this.codigoPlanillaActual = item.codigo;
      this.idPlanillaActual = item.id;
      this.dialogIncrementos = true;
      this.listarIncrementos();
    },
    listarIncrementos() {
      this.tableIncrementosLoading = true;
      let me = this;
      axios.get("api/Planillas/ListarIncrementos/" + this.idPlanillaActual)
        .then(function (response) {
          me.incrementosList = response.data;
          me.tableIncrementosLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          me.tableIncrementosLoading = false;
        });
    },
    agregarIncremento() {
      if (!this.formIncremento.mes_inicio || !this.formIncremento.mes_fin || !this.formIncremento.porcentaje) {
        this.$store.dispatch("setSnackbar", { text: "Complete los campos de incremento.", color: "error" });
        return;
      }
      this.btnIncrementoLoading = true;
      let me = this;
      axios.post("api/Planillas/AgregarIncremento", {
          id_planilla: this.idPlanillaActual,
          mes_inicio: this.formIncremento.mes_inicio,
          mes_fin: this.formIncremento.mes_fin,
          porcentaje: this.formIncremento.porcentaje
        })
        .then(function () {
          me.btnIncrementoLoading = false;
          me.formIncremento = { mes_inicio: null, mes_fin: null, porcentaje: null };
          me.listarIncrementos();
          me.$store.dispatch("setSnackbar", { text: "Incremento agregado exitosamente.", color: "success" });
        })
        .catch(function (error) {
          console.log(error);
          me.btnIncrementoLoading = false;
          me.$store.dispatch("setSnackbar", { text: "Hubo un error al agregar el incremento.", color: "error" });
        });
    },
    eliminarIncremento(item) {
      this.tableIncrementosLoading = true;
      let me = this;
      axios.delete("api/Planillas/EliminarIncremento/" + item.id)
        .then(function () {
          me.listarIncrementos();
          me.$store.dispatch("setSnackbar", { text: "Incremento eliminado exitosamente.", color: "success" });
        })
        .catch(function (error) {
          console.log(error);
          me.tableIncrementosLoading = false;
          me.$store.dispatch("setSnackbar", { text: "Hubo un error al eliminar el incremento.", color: "error" });
        });
    },
    manageDetalles(item) {
      this.$refs.detallesDialog.open(item.id);
    },
    listarDetalles() {
      let me = this;
      me.loadTableDetalles = true;
      axios.get(`api/planilla_detalles/listar/${this.planillaActual.id}`)
        .then(function (response) {
          me.planillaDetallesList = response.data;
          me.loadTableDetalles = false;
        })
        .catch(function (error) {
          me.loadTableDetalles = false;
          console.log(error);
        });
    },
    importarPersonas() {
      this.accionActual = 'importarPersonas';
      this.dialogActivacion = true;
    },
    confirmarImportarPersonas() {
      this.dialogActivacion = false;
      let me = this;
      axios.post(`api/planilla_detalles/ImportarPersonas/${this.planillaActual.id}`, {
        usuario: me.usuario
      })
      .then(function (response) {
        me.listarDetalles();
        me.$store.dispatch("setSnackbar", { text: "Personas importadas exitosamente.", color: "success" });
      })
      .catch(function (error) {
        me.$store.dispatch("setSnackbar", { text: "Error importando personas.", color: "error" });
      });
    }
  }
};
</script>
